import React, {Component} from 'react';
import {Table, Row, Col, Card, CardHeader, CardBody, Button, CardFooter} from 'reactstrap';
import {NavLink} from 'react-router-dom';
import { connect } from 'react-redux';
import { Redirect } from 'react-router-dom';
import $ from 'jquery';

class AccountAndBillingPage extends Component {


  constructor(props) {
    super(props);
     this.state = {
      navigate: false,
      path:"",
      result:Object
    };
  }


   componentWillMount() {
    let authToken = this.props.user.authToken;

     $.ajax({
          url: `https://screen.mobflic.com/v1/current-user`,
          type: 'GET',
          beforeSend: function (xhr) {
                  xhr.setRequestHeader ("X-Auth-Token",authToken);
          },
          success: (res) => {
            this.setState({
              result:res.result
            })
         },
        error: (res,a,b) => {
            console.log(res);
        }

      });


     if(!this.props.user.isLoggedIn) {
          this.setState({
            path:"login",
            navigate:true

          })
        }

   }



  render() {
       



     const { navigate, path } = this.state

      // here is the important part
      if (navigate) {
        console.log(path);
        return <Redirect to={ "/" + path } push={true} />
      }

      console.log(this.state.result);

    return (

      <div className="animated fadeIn">
         <Card>
              <CardHeader>
                Account And Billing Info
              </CardHeader>
              <CardBody>
                <Table hovered responsive>
                  <tbody>
                  <tr>
                    <td>Email</td>
                    <td>{ this.state.result.email }</td>
                  </tr>
                  <tr>
                    <td>CustomerType</td>
                    <td>{ this.state.result.customerType }</td>

                  </tr>
                  </tbody>
                </Table>
              </CardBody>
            </Card>

      </div>
    )
  }
}


function mapStateToProps(state) {
    return {
        user: state.activeUser,
    };
}


export default connect(mapStateToProps)(AccountAndBillingPage);



// WEBPACK FOOTER //
// ./src/views/Components/AccountAndBilling/accountAndBilling.js